// Static options that don't come from API
export const TABS = [
  { id: 0, label: "Tenant" },
  { id: 1, label: "Operations" },
  { id: 2, label: "Tenant Admin" }
];

export const CURRENCY_OPTIONS = [
  "USD", "EUR", "GBP", "INR", "AUD", "CAD", "JPY", "CNY"
];

export const ROLE_OPTIONS = [
  { value: "Admin", label: "Admin" },
  { value: "Manager", label: "Manager" },
  { value: "Viewer", label: "Viewer" }
];

export const ROLES_FOR_OPTIONS = [
  { value: "tenant admin", label: "Tenant Admin" },
  { value: "tenant user", label: "Tenant User" }
];

export const MOBILE_COUNTRY_CODE_OPTIONS = [
  { value: "+1", label: "+1 (US/CA)" },
  { value: "+44", label: "+44 (UK)" },
  { value: "+91", label: "+91 (IN)" },
  { value: "+61", label: "+61 (AU)" },
  { value: "+81", label: "+81 (JP)" },
  { value: "+86", label: "+86 (CN)" },
  { value: "+49", label: "+49 (DE)" },
  { value: "+33", label: "+33 (FR)" },
  { value: "+39", label: "+39 (IT)" },
  { value: "+55", label: "+55 (BR)" }
];

export const OPERATION_COUNTRY_OPTIONS = [
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "IN", label: "India" },
  { value: "AU", label: "Australia" },
  { value: "CA", label: "Canada" },
  { value: "DE", label: "Germany" },
  { value: "FR", label: "France" },
  { value: "IT", label: "Italy" },
  { value: "JP", label: "Japan" },
  { value: "CN", label: "China" },
  { value: "BR", label: "Brazil" },
  { value: "AE", label: "UAE" },
  { value: "SA", label: "Saudi Arabia" }
];